import { components } from '@/types/strapi';
import { SingleColumnPopupProps } from './SingleColumnPopup';
interface SingleColumnDiscountOfferProps
	extends Omit<SingleColumnPopupProps, 'content'> {
	content: components['schemas']['PopupSingleColumnNewsletterSignupComponent'];
}
export const SingleColumnNewsletterSignup = ({
	content,
}: SingleColumnDiscountOfferProps) => {
	return (
		<div className="newsletter-signup">
			<div className="mt-2 pb-8">
				<div className="flex flex-col space-y-4">
					<div className="mb-1 rounded-md bg-blue-50 p-3 text-center">
						<span className="text-sm text-blue-700">
							{content?.message}
						</span>
					</div>

					<div className="mt-2 flex items-center justify-center text-center text-xs text-gray-500">
						<svg
							className="mr-2 h-4 w-4 text-gray-400"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round">
							<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
						</svg>
						{content?.footer_message}
					</div>
				</div>
			</div>
		</div>
	);
};
